import { hot } from "react-hot-loader";

import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "../../../../shared/utilities/graphql/apolloClient";
import ListingProgressMenuContainer from "./ListingProgressMenuContainer";

const ListingProgressMenu = props => (
  <ApolloProvider client={apolloClient}>
    <ListingProgressMenuContainer {...props} />
  </ApolloProvider>
);

export default hot(module)(ListingProgressMenu);
